/**
 * FigJam color palette - matching the Figma plugin colors
 */
export const COLORS = {
  YELLOW: 'rgb(255, 217, 102)',
  SECTION_BG: '#FFFBF0',
  BLUE: '#80CAFF',
  GREEN: '#85E0A3',
  RED: '#FFAFA3',
  PINK: '#FFBDF2',
  PURPLE: '#D7AEFF',
  ORANGE: '#FFC470',
  LIGHT_GRAY: '#F5F5F5',
  GRAY: '#AFBCCF', // Match FigJam GRAY color
  DARK_GRAY: '#999999',
  BLACK: '#000000',
  WHITE: '#FFFFFF',
} as const;

/**
 * Sticky note colors rotation matching FigJam createStickySection
 * These colors rotate across different sections
 */
export const STICKY_COLORS = [
  '#85E0A3', // GREEN
  '#FFAFA3', // RED
  '#AFBCCF', // GRAY
  '#80CAFF', // BLUE
] as const;

/**
 * Font configurations matching FigJam/Figma plugin
 */
export const FONTS = {
  FAMILY: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  WEIGHTS: {
    REGULAR: '400',
    SEMI_BOLD: '600',
    BOLD: '700',
  },
} as const;

/**
 * Layout spacing constants from FigJam implementations
 */
export const SPACING = {
  SMALL: 8,
  MEDIUM: 16,
  LARGE: 24,
  XLARGE: 32,
  SECTION_PADDING: 40,
  STICKY_PADDING: 16,
  STICKY_GAP: 16,
  CARD_GAP: 20,
  STICKY_TEXT_EXTRA_SPACE: 0, // Extra space to improve text readability on sticky notes
} as const;

/**
 * Standard sizes for canvas elements
 */
export const SIZES = {
  STICKY_NOTE_WIDTH: 200,
  STICKY_NOTE_MIN_HEIGHT: 150,
  CARD_WIDTH: 280,
  CARD_MIN_HEIGHT: 120,
  CORNER_RADIUS: 8,
  STICKY_NOTE_CORNER_RADIUS: 0,
  CONNECTOR_STROKE_WIDTH: 2,
  AVATAR_SIZE: 80,
} as const;

/**
 * Shadow effects for depth
 */
export const SHADOWS = {
  STICKY_NOTE: {
    color: 'rgba(0, 0, 0, 0.2)',
    blur: 8,
    offset: { x: 0, y: 4 },
    opacity: 0.2,
  },
  CARD: {
    color: 'rgba(0, 0, 0, 0.08)',
    blur: 12,
    offset: { x: 0, y: 4 },
    opacity: 0.08,
  },
} as const;
